import React from "react";
import { withRouter, Link } from "react-router-dom";
// import rabbiImg from "../assets/images/newageislam-dummy.jpg";
import CommentListDetail from "./comment-detail-component";
import ArticleCommentForm from "./comment-form.component";
import ShareComponent from "./shareComponent";
const Detail = ({ article, history }) => {
  const {
    Article_Heading,
    // AutherName,
    Group_Name,
    ArticleContent,
    // ImageName,
    // ImageCaption,
    comments,
    Article_ID,
    Group_ID,
    CreatedDateTime,
    totalComments,
  } = article;
  const monthArr = [
    "Jan",
    "Feb",
    "March",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const sharedUrl = window.location.host.includes("localhost")
    ? `http://newageislam.com/${history.createHref(history.location)}`
    : window.location.href;
  const onViewAllComments = (articleId) => {
    history.push(`/viewComments/${articleId}`);
  };
  const DateStr = new Date(CreatedDateTime.split("T")[0]);
  return (
    <div className="col-12 col-sm-12 col-md-8 col-lg-7">
      <div className="sectionTitle blueTitleBg clearfix d-flex">
        <h2 className="m-0 float-left mr-auto px-3">
          {Group_Name}{" "}
          <small>
            ( {DateStr.getDate()} {monthArr[DateStr.getMonth()]}{" "}
            {DateStr.getFullYear()}
            {""}, NewAgeIslam.Com)
          </small>
        </h2>
        <a className="p-2" href="#viewComment" title="View Comment">
          <i className="fa fa-eye"></i> <span>Comment</span>
        </a>{" "}
        <span className="divide">|</span>
        <a className="p-2" href="#articleCommentForm" title="Write a Comment">
          <i className="fa fa-pencil-square-o"></i> <span>Comment</span>
        </a>
      </div>
      <div className="pageWrap p-3 bg-light shadow-sm">
        <div className="sharePost">
          <ShareComponent
            url={sharedUrl}
            hashtag={Article_Heading}
            content={Article_Heading}
          />
        </div>
        <div
          className={`articleListDetail ${Group_ID === 48 ? "urduFont" : ""}`}
        >
          <h2 className="mb-1">{Article_Heading}</h2>
          <div
            className="article-detail"
            dangerouslySetInnerHTML={{
              __html: ArticleContent
                ? ArticleContent
                : "<p><b>No Content available fo this article </b></p>",
            }}
          ></div>
          <div className="sharePost">
            <ShareComponent
              url={sharedUrl}
              hashtag={Article_Heading}
              content={Article_Heading}
            />
          </div>
          <div className="text-center donateBtn">
            <Link to="/donate" className="btn btn-warning rounded-0">
              <i className="fa fa-money"></i> Donate Now{" "}
            </Link>
          </div>
        </div>
      </div>
      <ArticleCommentForm
        ArticleID={Article_ID}
        CommentsCount={totalComments}
      />
      <CommentListDetail comments={comments} CommentsCount={totalComments} />
      <div className="viewCommentBtn text-center pt-3">
        <button
          className="btn btn-danger border-0 rounded-0 px-4"
          onClick={() => onViewAllComments(Article_ID)}
        >
          View All Comments ({totalComments})
        </button>
      </div>
    </div>
  );
};

export default withRouter(Detail);
